export enum ZIndex {
  NARRATOR_CONTAINER = 1500,
  POPOVER_MODAL = 11,
  DIM_BACKGROUND = 10,
  SORTABLE_TREE = 1,
  SCROLL_FOG = 1,
  LOADER = 1000,
  ANSWER_INTERVENTION_CONTENT = 0,
  POPUP = 1,
  PUBLIC_LAYOUT_BACKGROUND = 0,
  PUBLIC_LAYOUT_TOP_BACKGROUND = -1,
  QUESTION_TYPE_CHOOSER = 1,
  SIDE_PANEL_WRAPPER = 1,
  SIDE_PANEL_HANDLE_WRAPPER = 10,
  SIDEBAR = 10,
  GRID_QUESTION_LAYOUT_TH = 1,
  DRAGGED_TEST = 10000,
  NAVBAR = 10,
  NOTIFICATIONS_ICON = 11,
  NOTIFICATIONS_COUNTER = 12,
  QUESTION_SETTINGS_CONTAINER = 1,
  EDIT_SESSION_QUESTIONS_ROW = 2,
  QUICK_EXIT = 1001,
  CHAT_WIDGET = 11,
  TOOLTIP = 9999,
  ANIMATION_BORDER = 1,
  DROPDOWN = 999,
}
